import { InjectionToken } from '@angular/core';

export interface ChatConfig {
  /** e.g. `${environment.apiUrl}/chat` */
  apiUrl: string;
  /** e.g. `${environment.socketUrl}/ws`, or null to use the default relative `/ws` */
  socketUrl?: string;
}

export const CHAT_CONFIG = new InjectionToken<ChatConfig>('CHAT_CONFIG');

/** Minimal auth surface ChatWebSocketService/the shared room UI needs - every app's AuthService (via BaseAuthService) already has this. */
export interface ChatAuthLike {
  getAccessToken(): string | null;
  readonly isAuthenticated$: import('rxjs').Observable<boolean>;
  /** Used by ChatRoomListComponent/ChatRoomComponent to tell "me" apart from the other participant. */
  getCurrentUserId(): number | null;
}

export const CHAT_AUTH = new InjectionToken<ChatAuthLike>('CHAT_AUTH');
